/* Keep the app-owned subscription flow; make its injected collection triggers keyboard accessible. */
(() => {
  const root = document.querySelector('[data-cyber-lab]');
  if (!root || root.dataset.restockA11y) return;
  root.dataset.restockA11y = 'true';
  function enhance() {
    root.querySelectorAll('.sp4c-cyber-restock .product-restore-email[role="button"]').forEach(button => {
      button.tabIndex = 0;
      const name = button.closest('.sp4c-cyber-restock').querySelector('.sp4c-lpc__name').textContent.trim();
      button.setAttribute('aria-label', `Avísame cuando vuelva ${name}`);
    });
  }
  enhance();
  const observer = new MutationObserver(enhance);
  root.querySelectorAll('.sp4c-cyber-restock__signup').forEach(slot => {
    observer.observe(slot, { childList: true, subtree: true });
  });
  root.addEventListener('keydown', event => {
    if (!event.target.matches('.sp4c-cyber-restock .product-restore-email[role="button"]')) return;
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      const appTrigger = event.target.querySelector('.email-me-button');
      if (appTrigger) appTrigger.click();
    }
  });
  window.addEventListener('pagehide', () => observer.disconnect(), { once: true });
})();
